export default __webpack_public_path__ + "media/images/icons/shopping-cart-solid-d146d6c3c3d8c4e2f0b994e4dfba9f7a.svg";